import TableLinksList from './TableLinksList';

export default TableLinksList;
